import { useEffect, useState } from "react"
import { intComma } from "humanize-plus"
import classnames from "classnames"
import Spinner from "shared/components/spinner"
import { formatHexColorValue } from "shared/lib/alternate_brand_color"
import { pluralizeStepType } from "shared/lib/utils"
import { fetchSteps } from "./api"
import { StepMetrics } from "./types"

import styles from "./service_analytics.module.scss"

const Steps = ({
  serviceModuleName,
  serviceName,
  stepType,
}: {
  serviceModuleName: string
  serviceName: string
  stepType: string
}) => {
  const [loading, setLoading] = useState(true)
  const [metrics, setMetrics] = useState({} as StepMetrics)

  useEffect(() => {
    fetchSteps(stepType, serviceModuleName)
      .then(({ simple_service_metrics }: { simple_service_metrics: StepMetrics }) => {
        setMetrics(simple_service_metrics)
      })
      .catch(() => {
        window.appendFlash("Failed to fetch analytics metrics for this service", "danger")
      })
      .finally(() => setLoading(false))
  }, [])

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className={styles["step-module"]}>
        <div className={classnames(styles["stat-box"], styles.rounded)}>
          <p className="txt-body-3">
            Users with enabled Applets using {serviceName}'s {pluralizeStepType(stepType)}
          </p>
          <h3>{intComma(metrics.users_with_enabled_step_applets)}</h3>
        </div>
        <div className={classnames(styles["stat-box"], styles.rounded)}>
          <p className="txt-body-3">
            Applets using any of {serviceName}'s {pluralizeStepType(stepType)}
          </p>
          <h3>{intComma(metrics.applets_with_service_steps)}</h3>
        </div>
      </div>
      <div className={styles["step-header"]}>
        <h3>Usage</h3>
        <p className="txt-body-3">
          Number of users that have an enabled Applet using each of {serviceName}'s {pluralizeStepType(stepType)}
        </p>
      </div>
      <div className={styles.steps}>
        <ul className="web-applet-cards tqa">
          {metrics.step_metrics.map(({ step: { name }, users_with_enabled_step_applets }, i) => (
            <li className={classnames("my-web-applet-card web-applet-card web-applet-card-template tqa", styles.step)} key={i}>
              <div
                className="web-applet-card applet-card-body tqa"
                style={{ backgroundColor: formatHexColorValue(metrics.channel.brand_color) }}
              >
                <div className="tqa">
                  <p>{intComma(users_with_enabled_step_applets)} users</p>
                  <span className={styles["step-name"]}>{name}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default Steps
